import script from "./EditHolding.vue?vue&type=script&setup=true&lang=js"
export * from "./EditHolding.vue?vue&type=script&setup=true&lang=js"

import "./EditHolding.vue?vue&type=style&index=0&id=76422ee0&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76422ee0"]])

export default __exports__